// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3 1H15.4142L21 6.58579V23H3V1ZM14.5 3V7.5H19L14.5 3Z"}}]};

const FileFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-filled',
    ref,
    icon: element,
  },
));

FileFilledIcon.displayName = 'FileFilledIcon';

export default FileFilledIcon;
